var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlayStoreIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.35775 0.306144C3.1322 0.548495 3.00195 0.918837 3.00195 1.40354V18.5955C3.00195 19.0802 3.1322 19.4506 3.36552 19.6833L3.42579 19.7356L13.0847 10.1033V9.88807L3.41802 0.253784L3.35775 0.306144Z",
    fill: "url(#paint0_linear_360_4854)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2978 13.3241L13.0762 10.1114V9.88647L16.2978 6.67377L16.3677 6.71642L20.1784 8.87634C21.2691 9.489 21.2691 10.5011 20.1784 11.1215L16.3677 13.2815L16.2978 13.3241Z",
    fill: "url(#paint1_linear_360_4854)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3681 13.2814L13.0766 9.9989L3.35742 19.6913C3.71322 20.0713 4.3101 20.114 4.97695 19.7437L16.3681 13.2814Z",
    fill: "url(#paint2_linear_360_4854)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3681 6.71614L4.97695 0.263538C4.3101 -0.116478 3.71125 -0.0641192 3.35742 0.315897L13.0766 9.99862L16.3681 6.71614Z",
    fill: "url(#paint3_linear_360_4854)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M16.2982 13.2113L4.98476 19.6212C4.35288 19.9838 3.78907 19.9586 3.42551 19.629L3.36523 19.6891L3.42551 19.7414C3.78907 20.0691 4.35288 20.0962 4.98476 19.7337L16.3759 13.2811L16.2982 13.2113Z",
    fill: "#161616"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M20.1794 11.009L16.2891 13.2115L16.3591 13.2814L20.1697 11.1214C20.7161 10.8112 20.9844 10.4041 20.9844 9.99884C20.9513 10.3711 20.6733 10.724 20.1794 11.009Z",
    fill: "#161616"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.97728 0.376035L20.1791 8.98849C20.6729 9.26575 20.951 9.62834 20.9937 9.99865C20.9937 9.59344 20.7254 9.18626 20.1791 8.87606L4.97728 0.26357C3.88656 -0.358799 3.00195 0.160811 3.00195 1.40362V1.51609C3.00195 0.271316 3.88656 -0.238587 4.97728 0.376035Z",
    fill: "#161616"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_360_4854",
    x1: 9.15545,
    y1: 1.21807,
    x2: 0.893506,
    y2: 9.50284,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00657,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_360_4854",
    x1: 21.6008,
    y1: 9.99897,
    x2: 2.73614,
    y2: 9.99897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_360_4854",
    x1: 14.5783,
    y1: 13.0897,
    x2: 0.474787,
    y2: 27.2318,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_360_4854",
    x1: 0.910039,
    y1: -1.17859,
    x2: 7.205,
    y2: 5.13385,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayStoreIcon);
export default __webpack_public_path__ + "static/media/play-store-icon.4b105b6ac1b5c5256543c05873963616.svg";
export { ForwardRef as ReactComponent };